import React from 'react'
import {
  CustomerDeviceAuditMinSnapshotV1,
  CustomerDeviceAuditSnapshotV1,
  IAuditEventData,
} from '../../../api'
import { Accordion, Box } from 'cs-kevlar-react'
import { DetailField } from './DetailField'
import { UnavailableDetails } from './UnavailableDetails'
import { useDetailStyles } from './useDetailStyles'
import { DetailArrayField } from './DetailArrayField'
import { resolveEventData, resolveSnapshots } from './utils'
import { useAuth } from 'hooks/useAuth'

interface CustomerDeviceDetailsProps {
  eventData: IAuditEventData | null
}

export const CustomerDeviceDetails: React.FunctionComponent<CustomerDeviceDetailsProps> = ({
  eventData,
}) => {
  const { user } = useAuth()
  const classes = useDetailStyles()

  const [originalSnapshot, updatedSnapshot] = resolveSnapshots<
    CustomerDeviceAuditSnapshotV1
  >(eventData, nameof<CustomerDeviceAuditSnapshotV1>())

  const minSnapshot = resolveEventData<CustomerDeviceAuditMinSnapshotV1>(
    eventData,
    nameof<CustomerDeviceAuditMinSnapshotV1>(),
  )

  if (!updatedSnapshot && !originalSnapshot && !minSnapshot)
    return <UnavailableDetails />

  const showDiff = !!originalSnapshot && !!updatedSnapshot

  return (
    <React.Fragment>
      {!!minSnapshot && (
        <Box className={classes.fieldsContainer}>
          <DetailField label="Name" original={minSnapshot?.name} />
        </Box>
      )}

      {!minSnapshot && (
        <React.Fragment>
          <Box className={classes.fieldsContainer}>
            <DetailField
              label="Name"
              showDiff={showDiff}
              original={originalSnapshot?.name}
              updated={updatedSnapshot?.name}
            />

            <DetailField
              label="Assigned User"
              showDiff={showDiff}
              original={originalSnapshot?.assignedUserName}
              updated={updatedSnapshot?.assignedUserName}
            />

            <DetailField
              label="Notes"
              showDiff={showDiff}
              original={originalSnapshot?.notes}
              updated={updatedSnapshot?.notes}
            />
          </Box>

          {user?.isSupport == true && (
            <React.Fragment>
              <Accordion
                id="LoggingSettings"
                title="Logging Settings"
                initiallyExpanded
              >
                <Box className={classes.fieldsContainer}>
                  <DetailField
                    label="Enable Verbose Logging"
                    showDiff={showDiff}
                    original={originalSnapshot?.loggingConfig?.verboseLoggingEnabled?.toString()}
                    updated={updatedSnapshot?.loggingConfig?.verboseLoggingEnabled?.toString()}
                  />

                  <DetailArrayField
                    label="Enabled Types"
                    original={originalSnapshot?.loggingConfig?.enabledTypes}
                    updated={updatedSnapshot?.loggingConfig?.enabledTypes}
                    showDiff={showDiff}
                  />
                </Box>
              </Accordion>

              <Accordion
                id="CertificateSettings"
                title="Certificate Settings"
                initiallyExpanded
              >
                <Box className={classes.fieldsContainer}>
                  <DetailField
                    label="Allow Manual Renewal"
                    showDiff={showDiff}
                    original={originalSnapshot?.certificateConfig?.allowManualCertificateRenewal?.toString()}
                    updated={updatedSnapshot?.certificateConfig?.allowManualCertificateRenewal?.toString()}
                  />

                  <DetailField
                    label="Renewal Window In Seconds Override"
                    showDiff={showDiff}
                    original={originalSnapshot?.certificateConfig?.certificateRenewalWindowInSecondsOverride?.toString()}
                    updated={updatedSnapshot?.certificateConfig?.certificateRenewalWindowInSecondsOverride?.toString()}
                  />
                </Box>
              </Accordion>
            </React.Fragment>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  )
}
